export interface LatestResume {
  type: 'latestResume'
  hash: string
  filename: string
}

export const LatestResume = {
  make: (hash: string, filename: string): LatestResume => ({
    type: 'latestResume',
    hash,
    filename,
  }),
}
